import { createSlice } from '@reduxjs/toolkit';

// Messenger caps simultaneous popups too — past this, the tray would run off
// the edge of most screens. Opening one more than this evicts the oldest.
export const MAX_OPEN_CHATS = 3;

// Global state for the Facebook-style chat popups + call popup that can be
// opened from anywhere (e.g. the employee-detail sidebar's Call/Chat icons)
// and render docked bottom-right via ChatPopupTray / CallPopup, mounted once
// in DefaultLayout — see leftSideBar.jsx for the dispatch call sites.
const chatTrayReducer = createSlice({
  name: 'chatTrayReducer',
  initialState: {
    // [{ employeeId, name, avatar }] — one entry per open chat popup, oldest first
    openChats: [],
    // { employeeId, name, avatar } | null — at most one active call at a time
    activeCall: null,
  },
  reducers: {
    openChatWith: (state, action) => {
      const target = action.payload;
      if (!target?.employeeId) return state;
      if (state.openChats.some(c => c.employeeId === target.employeeId)) return state;
      const next = [...state.openChats, target];
      // Evict the oldest (front of the array) once past the cap, rather than
      // refusing to open the new one.
      if (next.length > MAX_OPEN_CHATS) next.shift();
      return { ...state, openChats: next };
    },
    closeChatWith: (state, action) => {
      const employeeId = action.payload;
      return { ...state, openChats: state.openChats.filter(c => c.employeeId !== employeeId) };
    },
    startCallWithTarget: (state, action) => {
      return { ...state, activeCall: action.payload };
    },
    endCallTray: (state) => {
      return { ...state, activeCall: null };
    },
  },
});

export const { openChatWith, closeChatWith, startCallWithTarget, endCallTray } = chatTrayReducer.actions;
export default chatTrayReducer.reducer;
